import { useAtomValue, useAtom } from 'jotai/index';
import { cityAtom } from '@app/atoms/app/city.atom.ts';
import { checkoutAtom } from '../../entites/cart/use-cart-products.store.ts';
import { useOrderService } from '../../entites/order/use-order.service.ts';
import { addToast } from '@heroui/react';
import { useNavigate } from 'react-router-dom';

export function useCheckout() {
  const city = useAtomValue(cityAtom);
  const navigate = useNavigate();

  const [data, setData] = useAtom(checkoutAtom);

  const service = useOrderService({
    onOrderCreated: (data) => {
      navigate(`/cart/checkout/${data.order.id}/success`);
      setData({ tab: 'pickup' });
    },
  });

  return {
    data: {
      submit: () => {
        if (data.tab === 'pickup' && !data.pharmacyId) {
          addToast({
            title: 'Внимание',
            description: 'Нужно выбрать пункт самовывоза',
            color: 'warning',
          });
          return;
        }
        if (
          data.tab === 'delivery' &&
          (!data.address || !data.build || !data.flat)
        ) {
          addToast({
            title: 'Внимание',
            description: 'Нужно указать адресс доставки',
            color: 'warning',
          });
          return;
        }
        service.create.trigger({
          city_id: city.id,
          delivery_type: data.tab,
          pharmacy_id: data.tab === 'pickup' ? data.pharmacyId || 0 : undefined,
          name: data.name || '',
          comment: data.comment,
          delivery_address:
            `${data.address || ''} ${data.build || ''} ${data.flat || ''} ${data.entrance || ''}`.trim(),
          success_url: 'https://zerde24.kz/cart/checkout/:orderId/success',
          failure_url: 'https://zerde24.kz/cart/checkout/:orderId/failure',
        });
      },
      city: city.name,
      tab: data.tab,
      pharmacyId: data.pharmacyId,
      name: data.name,
      setName: (value: string) => {
        setData((s) => ({ ...s, name: value }));
      },
      address: data.address,
      setAddress: (value: string) => {
        setData((s) => ({ ...s, address: value }));
      },
      build: data.build,
      setBuild: (value: string) => {
        setData((s) => ({ ...s, build: value }));
      },
      flat: data.flat,
      setFlat: (value: string) => {
        setData((s) => ({ ...s, flat: value }));
      },
      entrance: data.entrance,
      setEntrance: (value: string) => {
        setData((s) => ({ ...s, entrance: value }));
      },
      comment: data.comment,
      setComment: (value: string) => {
        setData((s) => ({ ...s, comment: value }));
      },
      paymentType: data.paymentType,
      setPaymentType: (value: string) => {
        setData((s) => ({ ...s, paymentType: value }));
      },
      setTab: (key: string) => {
        if (key === 'pickup' || key === 'delivery') {
          setData((s) => ({ ...s, pharmacyId: undefined, tab: key }));
        }
      },
    },
  };
}
